import { apiServiceClient } from "../config/api";

export const permissionsService = {
  async getCatalog() {
    return apiServiceClient.get("/admin/permissions/catalog");
  },

  async getRolesMatrix() {
    return apiServiceClient.get("/admin/permissions/matrix/roles");
  },

  async getUserEffective(userId, params = {}) {
    return apiServiceClient.get(`/admin/permissions/effective/${userId}`, params);
  },

  async grantUserPermission(userId, payload) {
    return apiServiceClient.post(`/admin/permissions/users/${userId}/grant`, payload);
  },

  async revokeUserPermission(userId, payload) {
    return apiServiceClient.post(`/admin/permissions/users/${userId}/revoke`, payload);
  },

  async grantRolePermission(role, payload) {
    return apiServiceClient.post(`/admin/permissions/roles/${role}/grant`, payload);
  },

  async revokeRolePermission(role, payload) {
    return apiServiceClient.post(`/admin/permissions/roles/${role}/revoke`, payload);
  },

  async bulkUpdateRolePermissions(role, payload) {
    return apiServiceClient.post(`/admin/permissions/roles/${role}/bulk`, payload);
  },

  async bulkUpdateUserPermissions(userId, payload) {
    return apiServiceClient.post(`/admin/permissions/users/${userId}/bulk`, payload);
  },
};

export default permissionsService;

